module.exports = __webpack_public_path__ + "images/emoji/nail_care.6c4c257ecb4b81bdae60.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/nail_care.png
// module id = 7KB1
// module chunks = 14